/* eslint-disable class-methods-use-this */
import BaseApi from './base-api';
import { BASE_API_FORM_TYPE_STRING } from './api-constants';

class SeedAuthenticationApi extends BaseApi {
  constructor() {
    super();
    this.url += 'user';
  }

  login(data) {
    const p = new Promise((resolve, reject) => {
      setTimeout(() => {
        if (data.email === 'hanmajid@gmail.com') {
          resolve({
            data: {
              data: {
                success: true,
                payload: {
                  user: data,
                  token: 'TOKEN',
                },
              },
            },
          });
        } else {
          reject(new Error('Wrong credentials'));
        }
      }, 1000);
    });
    return p;
    // return this.post('login', data, {
    //   headers: {
    //     'content-type': 'application/json',
    //   },
    // });
  }

  register(rawData) {
    const data = this.prepareData(this.prepareRawData(rawData), 'json');

    const p = new Promise((resolve, reject) => {
      setTimeout(() => {
        if (data.email !== 'hanmajid@gmail.com') {
          resolve({
            data: {
              data: {
                success: true,
                payload: {
                  user: data,
                  token: 'TOKEN',
                },
              },
            },
          });
        } else {
          reject(new Error('Email address is taken'));
        }
      }, 1000);
    });
    return p;

    // return this.post('register', data,
    //   {
    //     headers: {
    //       'content-type': 'multipart/form-data',
    //     },
    //   });
  }

  getById(id) {
    return this.get(`detail/${id}`);
  }

  updateProfile(id, rawData) {
    let isChangePassword = false;
    if (rawData.oldPassword.trim() !== '' || rawData.password.trim() !== '' || rawData.passwordConfirmation.trim() !== '') {
      isChangePassword = true;
    }
    const data = this.prepareData(this.prepareRawData(rawData, false, isChangePassword), 'form-data');

    return this.put(`${id}`, data,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      });
  }

  // eslint-disable-next-line class-methods-use-this
  prepareRawData(data) {
    return [
      {
        type: BASE_API_FORM_TYPE_STRING,
        trim: true,
        name: 'name',
        value: data.name,
      },
      {
        type: BASE_API_FORM_TYPE_STRING,
        trim: true,
        name: 'email',
        value: data.email,
      },
      {
        type: BASE_API_FORM_TYPE_STRING,
        name: 'password',
        value: data.password,
      },
    ];
  }
}

export default SeedAuthenticationApi;
